import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './languages/de.json';
import gb from './languages/gb.json';
import sl from './languages/sl.json';
import sr from './languages/sr.json';

export const resources = {
  // list of languages
  gb: {
    translation: gb,
  },
  de: {
    translation: de,
  },
  si: {
    translation: sl,
  },
  rs: {
    translation: sr,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    compatibilityJSON: 'v3', //issue on older versions of phone
    resources,
    defaultNS: 'translation',
    fallbackLng: 'gb',
  });

export default i18n;
